var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15 5C9.477 5 5 9.477 5 15s4.477 10 10 10a9.96 9.96 0 0 0 6.329-2.257l3.964 3.964a1 1 0 0 0 1.414-1.414l-3.964-3.964A9.96 9.96 0 0 0 25 15c0-5.523-4.477-10-10-10M7 15a8 8 0 1 1 16 0 8 8 0 0 1-16 0",
  clipRule: "evenodd"
})));
export default SvgIcSearch;